import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Ventures from './components/Ventures';
import Blog from './components/Blog';
import Newsletter from './components/Newsletter';
import Coaching from './components/Coaching';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import BlogPage from './components/BlogPage';

function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <About />
      <Ventures />
      <Blog />
      <Coaching />
      <Newsletter />
    </>
  );
}

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogPage />} />
      </Routes>
      <Footer />
      <WhatsAppFloat />
    </Router>
  );
}

export default App;
